import type React from 'react';
import { useCallback, useRef } from 'react';

type UseLatestReturn<T> = {
  ref: React.RefObject<T>;
  set: (value: T) => void;
};

/**
 * keeps a mutable ref that always holds the latest value.
 * also exposes a `set` method to imperatively update the ref.
 */
export function useLatest<T>(value: T): UseLatestReturn<T> {
  const ref = useRef<T>(value);
  ref.current = value;

  const set = useCallback((newValue: T) => {
    ref.current = newValue;
  }, []);

  return { ref, set };
}
